// removed by extract-text-webpack-plugin
module.exports = {"table":"tableTheme--table--2XJAnuWc","cellData":"tableTheme--cellData--3N7NPa1M","cellHeading":"tableTheme--cellHeading--2sW9nfG1","row":"tableTheme--row--1Sl1Wzim"};


//////////////////
// WEBPACK FOOTER
// ./src/App/events/Views/Detail/tableTheme.css
// module id = 546
// module chunks = 2